import React from 'react'
import { Link } from 'react-static'
import { Box } from 'grid-styled'
import { space } from 'styled-system'
import styled from 'styled-components'
import { Icon, ActiveBadge, DefaultBadge } from 'components'

const BoxIcon = Box.withComponent(Icon)

const TagBadgeLink = styled(Link)`
  display: inline-block;
  vertical-align: middle;
  ${space};
`

const TagBadge = ({ tag, active, ...rest }) => {
  const CurrentBadge = active ? ActiveBadge : DefaultBadge
  const link = active ? '/writing' : `/writing/tags/${tag.slug}/`
  return (
    <TagBadgeLink {...rest} to={link}>
      <CurrentBadge>
        {!active && <BoxIcon mr={2} name="tag" />}
        <span>{tag.title}</span>
        {active && <BoxIcon ml={2} mt="2px" name="close" />}
      </CurrentBadge>
    </TagBadgeLink>
  )
}
export default TagBadge



// WEBPACK FOOTER //
// /opt/build/repo/src/components/TagBadge.js